(function($) {

  $(function() {
    // trigger before ujs form submit event
    if ($.rails) {
      $(document.body)
        .on("keydown", "form.form[data-remote=true] textarea", function(e) {
          if (tower.metaKey(e) && e.which === 13) {
            e.preventDefault();
            $(this).closest("form.form").trigger('submit');
          }
        })
        .on("submit", "form.form", function(e) {
          var form = $(e.currentTarget),
            valid = true,
            selector = [
              "input[data-validate]:visible",
              "textarea[data-validate]:visible",
            ].join(',');

          form.find(selector).each(function(i, input) {
            if (!validateField($(input))) {
              valid = false;
            }
          });

          return valid;
        })
        .on("blur.validate", "input[data-validate]", function(e) {
          var input = $(this);
          if (input.attr("data-blur-validate") == "true") {
            validateField(input, true);
          }
        })
        .on("focus.validate", "input[data-validate]", function(e) {
          if (tower.mobile) {
            $(this).nextAll('.error').remove();
          }
        })
        .on("ajax:error", "form.form[data-remote=true]", function(e, xhr) {
          var form = $(e.currentTarget);
          var result;

          try {
            result = JSON.parse(xhr.responseText);
          } catch (e) {
            result = {}
          }

          if (!result || !result.errors) {
            return
          }

          var errors = result.errors;
          var handled = true;

          $.each(errors, function(i, err) {
            var field = form.find('input[name="' + err.target + '"], textarea[name="' + err.target + '"], select[name="' + err.target + '"], [target="' + err.target + '"]');
            var errorEl = field.nextAll(".error");

            if (field.length < 1) {
              handled = false;
              return;
            }

            if (!errorEl.length) {
              errorEl = $("<p class='error'></p>").insertAfter(field);
            }

            errorEl.html(err.msg);
            field.addClass("error")
              .nextAll(".desc").hide();
          });

          return !handled;
        })
        .on("ajax:beforeSend", "form.form[data-remote=true]", function(e, xhr, settings) {
          var btn = $(this).find('button[type=submit]');
          if (btn.is("[data-global-loading]")) {
            simple.loading({
              type: 'global',
              msg: btn.data("global-loading")
            });
          } else if (btn.is("[data-loading]")) {
            simple.loading({
              type: "tiny",
              el: btn
            });
          }
        })
        .on("ajax:complete", "form.form[data-remote=true]", function(e, xhr, status) {
          var btn = $(this).find('button[type=submit]');

          if (btn.is("[data-global-loading]")) {
            simple.loading.destroy();
          } else if (btn.is("[data-loading]")) {
            btn.data('loading').destroy();
          }

          if (status == "success") {
            var result;

            try {
              result = JSON.parse(xhr.responseText);
            } catch (e) {
              result = {}
            }

            var canLoad = $(".workspace").length;
            var button = $(this).find($.rails.enableSelector),
              successText = button.attr("data-success-text"),
              gotoUrl = result && result.target_url || button.attr("data-goto"),
              isRefresh = button.data("refresh");

            if (successText) {
              var timeoutDelay = button.attr("data-timeout-delay") || 3000;
              button.text(successText + " \u2713")
                .prop("disabled", true)
                .addClass("success");

              setTimeout(function() {
                button.text(button.data('ujs:enable-with'))
                  .prop('disabled', false)
                  .removeClass('success');
                pageLoad();
              }, timeoutDelay);
            } else {
              pageLoad();
            }

            function pageLoad() {
              if (gotoUrl) {
                var url = simple.url(gotoUrl);
                var currentUrl = simple.url();
                var stackRoot = (result && result.target_root) || button.is('[data-goto-root]');
                var stackParent = result && result.target_parent;

                if (url.toString("relative") !== currentUrl.toString("relative")) {
                  if (tower.stack && canLoad) {
                    tower.stack.load(gotoUrl, {
                      replace: true,
                      root: stackRoot,
                      parent: stackParent
                    });
                  } else if (tower.mobile) {
                    tower.visit(gotoUrl);
                  } else {
                    location.href = gotoUrl;
                  }
                } else {
                  isRefresh = true;
                }
              }

              if (isRefresh) {
                if (tower.stack && canLoad) {
                  tower.stack.load(location.href, {
                    nocache: true,
                    replace: true
                  });
                } else if (tower.mobile) {
                  tower.visit(location.href);
                } else {
                  location.reload();
                }
              }
            }

            if (successText || gotoUrl || isRefresh) {
              return false;
            }
          }
        })
        .on("ajax:complete", $.rails.linkClickSelector, function(e, xhr, status) {
          var link = $(this);

          if (link.is("[data-global-loading]")) {
            simple.loading.destroy();
          } else if (link.is("[data-loading]")) {
            link.data('loading').destroy();
          }

          if (link.is('.btn[data-disable-with]')) {
            link.text(link.data('ujs:enable-with'))
              .prop('disabled', false)
              .removeClass('disabled');
          }

          if (status == "success") {
            var result;

            try {
              result = JSON.parse(xhr.responseText);
            } catch (e) {
              result = {}
            }
            var gotoUrl = result && result.target_url || link.attr("data-goto");
            var isRefresh = link.data("refresh");
            var canLoad = $(".workspace").length;

            if (gotoUrl) {
              var url = simple.url(gotoUrl);
              var currentUrl = simple.url();
              var isReplace = link.is('[data-stack-replace]');
              var stackRoot = (result && result.target_root) || link.is('[data-goto-root]');
              var stackParent = result && result.target_parent;

              if (url.toString("relative") !== currentUrl.toString("relative")) {
                if (tower.stack && canLoad) {
                  tower.stack.load(gotoUrl, {
                    replace: isReplace,
                    root: stackRoot,
                    parent: stackParent
                  });
                } else if (tower.mobile) {
                  tower.visit(gotoUrl);
                } else {
                  location.href = gotoUrl;
                }
              } else {
                isRefresh = true;
              }
            }

            if (isRefresh) {
              if (tower.stack && canLoad) {
                tower.stack.load(location.href, {
                  nocache: true,
                  replace: true
                });
              } else if (tower.mobile) {
                tower.visit(location.href);
              } else {
                location.reload();
              }
            }
          }
        })
        .on("ajax:beforeSend", $.rails.linkClickSelector, function(e, xhr, settings) {
          var link = $(this);
          if (link.is("[data-global-loading]")) {
            simple.loading({
              type: 'global',
              msg: link.data("global-loading")
            });
          } else if (link.is("[data-loading]")) {
            simple.loading({
              type: "tiny",
              el: link
            });
          } else if (link.is('.btn[data-disable-with]')) {
            link.addClass('disabled');
          }
        });
    }

    function validateField(input, blur) {
      var rules = input.attr("data-validate"),
        msgs = input.attr("data-validate-msg"),
        val = input.val(),
        valid = true,
        error = "",
        inputName = input.attr('name');

      if (rules) {
        rules = rules.split(";");
      } else {
        return valid;
      }

      if (msgs !== undefined) {
        msgs = msgs.split(";");
      }

      $.each(rules, function(i, rule) {
        var rule = $.trim(rule).split(":"),
          type = rule[0],
          args = rule.length > 1 ? rule[1] : null,
          result = null;

        if (type == "custom") {
          var event = $.Event("validate");
          input.trigger(event, [val, args]);
          result = event.result || { valid: true };
        } else {
          result = tower.validate[type](val, args);
        }

        if (!result.valid) {
          valid = result.valid;

          if (msgs && msgs.length && msgs[i]) {
            error = msgs[i];
          } else if (result.errorMsg) {
            error = result.errorMsg;
          } else {
            error = '';
          }

          if (type == 'required' && blur) {
            valid = true;
            error = '';
          }

          return false;
        }
      });

      if (!valid) {
        input.addClass("error")
          .nextAll(".desc")
          .hide();

        if (error) {
          input.nextAll('p.error').remove()
          var errorEl = $('<p class="error" for="' + inputName + '"></p>').appendTo(input.parent());

          errorEl.text(error).show();
        }
      } else {
        input.removeClass("error")
          .nextAll(".desc")
          .show()
          .end()
          .nextAll('p.error[for="' + inputName + '"]')
          .remove();
      }

      return valid;
    }

    $.extend(window.tower, {
      validate: {
        required: function(val, args) {
          return {
            valid: !!$.trim(val),
            errorMsg: "请填写这个字段"
          };
        },
        length: function(val, args) {
          args = (args || "0").split(",");
          var len = val.length,
            min = args[0] * 1,
            max = args.length > 1 ? args[1] * 1 : null;

          return {
            valid: !val || (len >= min && (!max || len <= max)),
            errorMsg: "这个字段的长度不能" + (min > 0 ? "少于" + min + "位" : "") + (max ? "多余" + max + "位" : "")
          };
        },
        range: function(val, args) {
          args = (args || "0").split(",");
          var min = args[0] * 1,
            max = args.length > 1 ? args[1] * 1 : null;
          return {
            valid: !val || (val >= min && (!max || val <= max)),
            errorMsg: "这个字段的值" + (min > 0 ? "不能小于" + min : "") + (max ? "不能大余" + max : "")
          };
        },
        email: function(val, args) {
          var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return {
            valid: !val || re.test(val),
            errorMsg: "请填写正确的邮箱地址"
          };
        },
        number: function(val, args) {
          return {
            valid: !val || /^\d+$/.test(val),
            errorMsg: "请填写数字"
          };
        },
        mobile: function(val, args) {
          return {
            valid: !val || /^\d{11}$/.test(val),
            errorMsg: "请填写有效的手机号码"
          };
        },
        phone: function(val, args) {
          return {
            // include +86-12345678 400-800-2322 18615706914 86-18615706914
            valid: !val || /^(\+)?[0-9]+(-[0-9]+)*$/.test(val),
            errorMsg: "请填写有效的联系电话"
          }
        },
        taxId: function(val, args) {
          return {
            valid: !val || /[a-zA-Z\d]{15}|[a-zA-Z\d]{18}|[a-zA-Z\d]{20}/.test(val),
            errorMsg: "请填写有效的纳税人识别号"
          }
        },
        confirmation: function(val, args) {
          return {
            valid: !val || $(args).val() == val,
            errorMsg: '与确认值不一致'
          }
        }
      }
    });
  });

})(jQuery);
